import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {DustDbModel, GasDbModel} from '@/sdk';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class PreviewDustDbRecordDialogComponent extends VueWrapper {
    public readonly name: string = 'preview-dust-db-record-dialog';

    @Prop({
        type: Object,
        required: true,
    })
    public obj!: DustDbModel;

    public open() {
        this.CoreSrv.OpenModal(this.name);
    }

    public close() {
        this.CoreSrv.CloseModal(this.name);
    }
}
